import { render, staticRenderFns } from "./AddNewPaymentMethodForm.vue?vue&type=template&id=3cb65b8b&"
import script from "./AddNewPaymentMethodForm.vue?vue&type=script&lang=js&"
export * from "./AddNewPaymentMethodForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports